import { EFFECTS, ALL_STAGES, validBehaviorsForStage, type Stage } from '@capture/shared';
import type { Behavior } from '@capture/shared';

/** The six Fill/transform effect keys → the persisted behavior `kind` each compiles to. */
export const EFFECT_TO_KIND: Record<string, Behavior['kind']> = {
  compute: 'compute',
  substitute: 'substitute',
  transform: 'transform',
  parse_split: 'parse',
  populate_source: 'populate',
  webhook_lookup: 'webhook',
};

export function kindForEffect(effectKey: string): Behavior['kind'] | null {
  return EFFECT_TO_KIND[effectKey] ?? null;
}

/** The registry's Fill/transform effects (palette source), in registry order. */
export const FILL_TRANSFORM_EFFECTS = EFFECTS.filter((e) => e.bucket === 'fill_transform');

/**
 * The pipeline stages a behavior of this kind may run at, in canonical
 * ALL_STAGES order — the WHEN vocabulary for the effect (from the shared
 * STAGE_TO_BEHAVIORS validity map).
 */
export function stagesForKind(kind: Behavior['kind']): Stage[] {
  return ALL_STAGES.filter((s) => validBehaviorsForStage(s).includes(kind));
}
